import type { CampaignSimpleResponse, PopupResponse } from '@coorum-research/shared-common/api-response/popup.schema'
import { Provider, atom, createStore, useAtom } from 'jotai'
import { setPopupAnimationClass } from '../utils/render-research.util'
import { getResearchReactRootContainer } from '../utils/RenderResearchPage'
import { CoorumResearch, type PageMode } from './CoorumResearch'

export type RenderResearchComponentProps = {
  show: boolean
  initPage?: PageMode
  popup?: PopupResponse | null
  campaign?: CampaignSimpleResponse | null
  onShow?: () => void
  onClose?: () => void
}

export const researchPagePropAtom = atom<RenderResearchComponentProps>({ show: false })
const researchPagePropStore = createStore()

export const showResearchPage = (researchContainerEl: HTMLElement, props: RenderResearchComponentProps) => {
  setPopupAnimationClass(researchContainerEl, 'open')
  researchPagePropStore.set(researchPagePropAtom, props)
}

export const hideResearchPage = (researchContainerEl: HTMLElement) => {
  setPopupAnimationClass(researchContainerEl, 'close')
  researchPagePropStore.set(researchPagePropAtom, { show: false })
  setTimeout(() => {
    researchContainerEl.setAttribute('style', 'display:none;')
  }, 200)
}


function ChildWrap() {
  const [researchPageProp] = useAtom(researchPagePropAtom)
  const { show, popup, campaign, initPage, onShow, onClose } = researchPageProp

  // researchContainerEl
  const researchContainerEl = getResearchReactRootContainer()!

  const handleClose = () => {
    hideResearchPage(researchContainerEl)

    if (onClose) {
      onClose()
    }
  }

  const initialMode = initPage ? initPage : (campaign || popup?.campaigns?.length === 1 ? 'survey' : 'CampaignSelection')

  // const initialCampaign = initialMode === 'survey' ? campaign ? campaign : (popup?.campaigns && popup?.campaigns?.length > 0) ? popup.campaigns[0] : null : null
  let initialCampaignId: string | null = null
  if (initialMode === 'survey') {
    if (campaign) {
      // キャンペーン指定があるなら、そのキャンペーンを初期表示する
      initialCampaignId = campaign.id
    } else {
      // キャンペーン指定がない場合、最初のキャンペーンを初期表示する
      if (popup?.campaigns && popup?.campaigns?.length > 0) {
        initialCampaignId = popup.campaigns[0].id
      }
    }
  }

  return (
    <>
      {show && (
        <CoorumResearch
          initialMode={initialMode}
          initialCampaignId={initialCampaignId}
          campaignSelectionContentId={popup?.campaignSelectionContentId}
          popup={popup ?? undefined}
          popupTheme={popup?.configJson?.theme}
          campaigns={campaign ? [campaign] : popup?.campaigns}
          onShow={onShow}
          onClose={handleClose}
        />
      )}
    </>
  )
}

export function PageStoreProvider() {
  return (
    <Provider store={researchPagePropStore}>
      <ChildWrap />
    </Provider>
  )
}
